import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';

export const UploadBundlesRequestConfig: Omit<RestApiRequestConfig<UploadBundlesRequestBody>, 'requestBody' | 'headers' | 'queryParams'> = {
  restApiVersion: '3.12',
  httpMethod: 'POST',
  endpoint: 'publishBundles',
};

export interface UploadBundlesQueryParams {
  bundleIds: string[];
  oauthId: number;
}

export type UploadBundlesRequestBody = Blob;

export interface UploadBundlesResponse {
  jobId: string;
  pollingInterval: string;
}

export function callViaApiService<UploadBundlesResponse>(
  body: UploadBundlesRequestBody,
  headers: {[index: string]: string},
  queryParams: UploadBundlesQueryParams
) {
  const config: RestApiRequestConfig<UploadBundlesRequestBody, UploadBundlesQueryParams> = {
    ...UploadBundlesRequestConfig,
    requestBody: body,
    headers,
    queryParams,
  };
  return makeRestApiRequest<Blob, UploadBundlesResponse>(config);
}

